<section *ngIf="!isSelectedMultipleLoc">
  <div class="modal-header header-style">
    <div>
      <button class="btn-close" (click)="modal.dismissAll()"
        [ngStyle]="{'background-image': 'url(../../assets/icons/'+baseSiteId+'/close.svg)'}"></button>
    </div>
    <br>
    <div class="mt-2">
      Select Products For Future Shipments
    </div>
  </div>
  <div class="modal-body body-style">
    <div>Add the following items to your cart, schedule your shipments and checkout, or
      continue to browse.
    </div>
    <hr>
    <!-- <div> -->
    <div class="row modal-bottom" *ngFor="let item of futuerShipList">
      <div class="col-md-2">
        <a href="javascript:void(0);">
          <img class="image-align" [src]="getImage(item)">
          <!-- <img class="image-align" [src]="item.url"> -->
          <!-- <cx-media class="cx-product-image" [container]="getImage(item.images)" format="thumbnail" [alt]=""></cx-media> -->
        </a>
        <!-- <a href="javascript:void(0);" *ngIf="!isImagePresent">
          <img class="image-align" [src]="defaultImg">
        </a> -->
      </div>
      <div class="col-md-5 item-style text-left">
        <div [innerHTML]="item.baseProductName"></div>
        <div [innerHTML]="item.baseProductDescription" class="mt-1"></div>
        <div class="mt-1" [innerHTML]="item.variantProductDescription"></div>
        <div class="ndcCode">{{item.ndcCode}}</div>
        <div class="mt-1"><b class="mr-1">{{item.code}}</b><span>|</span><span class="ml-1">{{item.manufacturer}}</span>
        </div>
        <div class="mt-1" *ngIf="item.priceInfos?.conditions as contractGroups">
          <div>Contract Group</div>
          <ng-select *ngIf="contractGroups.length > 1; else singleContract" [items]="contractGroups"
            [searchable]="false" [clearable]="false" bindLabel="contractDesc" bindValue="contractId"
            placeholder="Select Contract Group" class="mt-1 dropdown-contractGroup"
            (change)="onChange($event,item.code)">
          </ng-select>
          <ng-template #singleContract>
            <span [ngStyle]="{
              'font-size.px': '14',
              color: '#313131',
              'text-transform': 'uppercase'
            }">
              {{ contractGroups[0].contractDesc }}
            </span>
          </ng-template>
        </div>
      </div>
      <div class="col-md-2 text-left price-style">
        <div>Your Price</div>
        <div id="{{item?.code}}">{{item.priceInfos && !item?.hidePriceForProduct ? getPrice(item) : "$--"}}</div>
        <span *ngIf="item?.priceInfos?.fexciseTax && item?.priceInfos?.fexciseTax?.value > 0.00 && !item?.hidePriceForProduct">
          {{item?.priceInfos?.fexciseTax?.value | currency}}
          {{item?.priceInfos?.fexciseTax?.currencyIso}}/
          {{item?.product?.unit}}
          federal excise tax
          will be added.
        </span>
        <div *ngIf="isFormularyCustomer && !item.formularyProduct" class="formulary-section">
          <span>This product is not in your formulary</span>
          <div>
            <a [ngbPopover]="popSaveContent" placement="top" #s3="ngbPopover" triggers="manual"
              popoverClass="savedordermini-popover" (click)="openPopup(s3)">View details</a>
          </div>
          <ng-template #popSaveContent>
            <div class="mb-3 popover-body-content">
              This product request is outside your approved formulary and cannot be ordered at this time. Please talk to
              your Contract Administrator/Purchasing Department to add products to your approved formulary.
            </div>
            <a (click)="navigateFormulary(s3)">View your current approved products</a>
            <div>
              <span class="mt-2 mb-3 popover-body-content" *ngIf="baseSiteId == 'vsh'">For more information contact
                1-800-VACCINE
                (1-800-822-2463)</span>
              <span class="mt-2 mb-3 popover-body-content" *ngIf="baseSiteId == 'vax'">For more information contact
                1-800-752-9338</span>
            </div>
          </ng-template>
        </div>
      </div>
      <div class="col-md-3 units">
        <span class="unit-style">{{'Units'}}</span>
        <section class="unit-area" *ngIf="getFormularyStatus(item.formularyProduct)">
          <span class="disabled pointer-style" aria-hidden="true" id="{{'minusIcon'+item?.code}}">
            <img [src]="'../../assets/icons/'+baseSiteId+'/less_new.svg'" id="{{'unitMinus'+item?.code}}"
              class="disabled-img" alt=""
              (click)="performQuantityComputation(2,item?.code,item.quantityPerUnit,item.uom,item)">
            <img [src]="'../../assets/icons/'+baseSiteId+'/less-disable_new.svg'" id="{{'unitMinusDisable'+item?.code}}"
              alt="" class="disablemore">
          </span>
          <input type="number" class="prod-quantity text-center" [value]="0" (keyup)="performQuantityComputation(null,item?.code,
          item.quantityPerUnit,item.uom,item)" id="{{'prodQuantity'+item?.code}}" maxlength="4"
            (keydown)="validateInput($event)" appNoMouseScroll />
          <span class="pointer-style" aria-hidden="true" id="{{'plusIcon'+item?.code}}">
            <img [src]="'../../assets/icons/'+baseSiteId+'/more.svg'" id="{{'unitPlus'+item?.code}}" alt=""
              (click)="performQuantityComputation(1,item?.code,item.quantityPerUnit,item.uom,item)">
            <img class="disabled-img" [src]="'../../assets/icons/'+baseSiteId+'/more-disable.svg'"
              id="{{'unitPlusDisable'+item?.code}}" alt="">
          </span>
          <section class="dosessection" id="{{'noOfDoses'+item?.code}}">
            {{'0 ' +item.uom}}</section>
        </section>
        <section class="unit-area" *ngIf="!getFormularyStatus(item.formularyProduct)">
          <span class="disabled pointer-style" aria-hidden="true">
            <img [src]="'../../assets/icons/'+baseSiteId+'/less-disable_new.svg'" alt="" class="disablemore">
          </span>
          <input type="number" class="prod-quantity text-center" [value]="0" disabled />
          <span class="pointer-style" aria-hidden="true" id="{{'plusIcon'+item?.code}}">
            <img [src]="'../../assets/icons/'+baseSiteId+'/more-disable.svg'" alt="">
          </span>
          <section class="dosessection">
            {{'0 ' +item.uom}}</section>
        </section>
      </div>
    </div>
    <!-- </div> -->
  </div>
  <div class="modal-footer footer-style justify-content-center flex-column">
    <!-- <section class="plpbutton btn-style"> -->
    <button type="button" class="btn-primary future-prim" [disabled]="!isUnitAdded || blockOrder" (click)="checkOutOrAddToCart(true)">
      Checkout
    </button>
    <button type="button" class="btn-secondary mt-2 future-sec" [disabled]="!isUnitAdded || blockOrder" (click)="checkOutOrAddToCart(false)">
      Add to cart
    </button>
    <!-- </section> -->
  </div>
</section>
<section *ngIf="isSelectedMultipleLoc">
  <div class="modal-header header-style justify-content-center">
    <div class="mt-2">
      Please Note
    </div>
  </div>
  <div class="modal-body body-multiloc-style">
    <div>If you plan to schedule these doses as future shipments, you'll need to checkout separately for each location.
    </div>
    <div>We apologize for any inconvenience.
    </div>
  </div>
  <div class="modal-footer footer-style justify-content-center">
    <section class="col-md-12">
      <button type="button" class="btn-secondary w-100" (click)="modal.dismissAll()">
        Close
      </button>
    </section>
  </div>
</section>